import { asNumber, asString, isObject, parseList } from "./model-utils";

export class DeliveryFeeEstimateOption {
  [key: string]: any;
  constructor(json: any = {}, currency?: any) {
    Object.assign(this, json);
    this.vehicleType = asString(json.vehicleType);
    this.deliveryFee = asNumber(json.deliveryFee);
    this.currency = asString(json.currency) || currency;
    this.breakdown = isObject(json.breakdown)
      ? { ...json.breakdown }
      : json.breakdown;
  }

  static fromJson(json: any, currency?: any) {
    return isObject(json) ? new DeliveryFeeEstimateOption(json, currency) : json;
  }
}

export class DeliveryFeeEstimate {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.currency = asString(json.currency);
    this.estimatedDelivery = asString(json.estimatedDelivery);
    this.distance = isObject(json.distance)
      ? { ...json.distance }
      : json.distance;
    const options = parseList(json.options, (option) =>
      DeliveryFeeEstimateOption.fromJson(option, this.currency),
    );
    this.options =
      options.length > 0
        ? options
        : [
            ...(json.deliveryFee !== undefined
              ? [
                  new DeliveryFeeEstimateOption(
                    {
                      vehicleType: json.vehicleType || "delivery",
                      deliveryFee: json.deliveryFee,
                      currency: json.currency,
                      breakdown: json.breakdown,
                    },
                    this.currency,
                  ),
                ]
              : []),
          ];
  }

  static fromJson(json: any) {
    return isObject(json) ? new DeliveryFeeEstimate(json) : json;
  }
}
